import { DiagnosticCollectionFormValue } from '.'
import { toast } from '@contrast-security-inc/design-system-alerts'
import { DefaultDiagnosticCollectionValues } from './diagnostic-collection-state-manager'
import { validDurationDisplay } from './diagnostic-collection-form-view'

export function updateDiagnosticCollectionSettings({
  logLevel,
  duration
}: DiagnosticCollectionFormValue): DiagnosticCollectionFormValue {
  const validDuration: boolean =
    duration === 0 || validDurationDisplay(logLevel, duration)

  if (!validDuration) {
    toast('Invalid Diagnostic Collection Settings.', { variant: 'error' })
    throw new Error(
      'Ensure Debug log level duration between 1 and 24. Ensure Trace log level duration between 1 and 6.'
    )
  }

  return {
    enabled: duration > 0 || DefaultDiagnosticCollectionValues.enabled,
    logLevel: logLevel || DefaultDiagnosticCollectionValues.logLevel,
    duration: duration || DefaultDiagnosticCollectionValues.duration
  }
}
